// extracted by mini-css-extract-plugin
module.exports = {"style":{"fontFamily":"'__Lato_06d0dd', '__Lato_Fallback_06d0dd'","fontStyle":"normal"},"className":"__className_06d0dd","variable":"__variable_06d0dd"};